module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-161.44f91f1.woff2";